import {
  addRumResponseError,
  RUM_SKIP_INTERCEPTOR_ERROR_TRACKING,
} from '@/Hooks/Shared/useRumCustomAction'
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: window.ARYEO_COMPANY_API_V1_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'accept-language': navigator.language,
  },
})

axiosInstance.interceptors.response.use(
  (response) => response, // Directly return successful responses
  (error) => {
    if (error.response && !error.config[RUM_SKIP_INTERCEPTOR_ERROR_TRACKING]) {
      addRumResponseError(error)
    }

    // MANDATORY: Return a rejected promise to allow local .catch() if needed
    return Promise.reject(error)
  }
)

export default axiosInstance
